/**
 * 支払方法
 */
export const PayMethod = {
  // 口座振替
  account: '1',

  // クレジット
  credit: '2',
} as const;
